import { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const PrivateRoute = () => {
    const location = useLocation();
    let pathname = location.pathname; 
    let pathnameRemovedLast = location.pathname.split('/').slice(0, -1).join('/'); // for user detail , remove 'userId' part
    const token = localStorage.getItem('token');
    useEffect(() => {
        if(pathname === "/user/list" || pathnameRemovedLast === "/user/detail") return;
        // reset the store value
        localStorage.setItem('list-userId', "");
        localStorage.setItem('list-username', "");
        localStorage.setItem('list-page', "");
    },[pathname])

  
    return token ? <Outlet /> : <Navigate to="/login" replace />;
  
};
  
export default PrivateRoute;